<template>
  <!-- Header -->
  <section class="hero is-link is-fullheight is-fullheight-with-navbar" v-if="header">
    <div class="hero-body" :style="'background: linear-gradient(rgba(255, 255, 255, 1),rgba(255, 255, 255, 0.4),rgba(255, 255, 255, 0.4)), url('+fond.img+'); background-size: cover; background-position: center; background-repeat: no-repeat;'">
      <div class="container is-fullwidth has-text-centered">
        <figure class="websiteLogo" v-if="header.img">
          <img :src="header.img" alt="image" style="max-height: 150px; min-width: 200px;">
        </figure>
        <h2 class="subtitle is-5">
          {{header.titre}}
        </h2>
      </div>
    </div>
  </section>
</template>

<script>
import { settingsRef, mediaRef, contentsRef, routesRef } from '@/admin/firebase_config'
import contentFetch from '@/admin/mixins/contentFetch'

export default {
  name: 'headerHero',
  props: {
  },
  mixins: [contentFetch],
  firebase: {
    // load settings as object instead of array (default)
    settings: {
      source: settingsRef,
      asObject: true
    },
    contents: contentsRef,
    media: {
      source: mediaRef
    },
    routes: routesRef
  },
  data () {
    return {
    }
  },
  methods: {
  },
  computed: {
    header () {
      return this.getContentsByType('Header')[0]
    },
    fond () {
      return this.getContentsByType('Fond')[0]
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '../styles/index.scss';
  .hero-body{
    background-size: cover;
    background-position: center;
  }
  .subtitle{
    font-weight: 100;
    padding-top: 1em;
    color: black !important;
    text-transform: none;
  }
</style>



// WEBPACK FOOTER //
// src/app/components/headerHero.vue